<template>
    <div class="flex flex-col items-center justify-between w-7 h-7">
        <svg fill="white" class="rotate-45" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                d="M272 240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H272V496C272 504.8 264.8 512 255.1 512C247.2 512 239.1 504.8 239.1 496V272H16C7.164 272 0 264.8 0 256C0 247.2 7.164 240 16 240H239.1V16C239.1 7.164 247.2 0 255.1 0C264.8 0 272 7.164 272 16V240z"/>
        </svg>
    </div>
</template>
